module.exports = __webpack_public_path__ + "static/img/todoWork.f19bc7b8.webp";